exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ivu-col-span-13[data-v-e549542c]{width:45.3%}.ivu-col-span-17[data-v-e549542c]{width:99%}.ivu-col-span-10[data-v-e549542c]{width:53.6%}.ivu-col-span-5[data-v-e549542c]{width:26.8%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e549542c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/selectors/NewAreaSelector.vue
// module id = 797
// module chunks = 3